




























import ClickOutsideDirective from '@/shared/directives/click-outside-directive'
import {defineComponent, getCurrentInstance, onMounted, PropType, ref, Ref} from "@vue/composition-api"
import {Config} from "./models/config-viewmodel"
import {useActions, useGetters} from "vuex-composition-helpers"

export default defineComponent({
    name: "MyStudyChoiceCreatedWidget",
    components: {},
    directives: {
        ClickOutsideDirective
    },
    props: {
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props) => {
        const {setConfig} = useActions([
            'setConfig'
        ]);
        setConfig(props.config)
        const {labels} = useGetters(['labels']);
        let created: Ref<boolean> = ref(false);

        function closeMenu(): void {
            created.value = false
        }

        onMounted(() => {
            let isShown = localStorage?.getItem('my-study-choice-created');
            if (!isShown) {
                created.value = true
            }
            localStorage?.setItem('my-study-choice-created', '1');
            getCurrentInstance()?.proxy?.$on('clickOutside', () => {
                closeMenu()
            })
        })

        return {
            closeMenu,
            created,
            labels
        }
    }
})
